/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc
 */

export const inviteUserRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'inviteUser',
  auth: 'external',
  fingerprint: 'eVWmL1WtVnMKu6jTTwWasL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const acceptInvitationRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'acceptInvitation',
  auth: 'external',
  fingerprint: 'cZx62JgBWbVl2Y50fi73eb5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listUserInvitationsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'listUserInvitations',
  auth: 'external',
  fingerprint: 'LRXegvA2nlRrK9MSbE_buL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninviteUserRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'uninviteUser',
  auth: 'external',
  fingerprint: 'jVSXuEhX1e60nC25eJ-tVL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const changeUserRoleRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessDelegationRpc',
  rpcName: 'changeUserRole',
  auth: 'external',
  fingerprint: 'HVYuY1rqKRi5VMyrzsrZfb5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};